export default __webpack_public_path__ + "6d0c41dab1b4279942e626bed2a4559e.png";